import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginService } from '../service/login.service';
import { UserService } from '../service/user.service';
import { MenuService } from '../../app/service/menu.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  loginusername: string = '';
  loginpassword: string = '';
  loginError: boolean = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private menuService: MenuService) { }

  ngOnInit(): void {
    
    sessionStorage.clear();
  }

  onSidebarLinkClick(linkName: string) {
    this.menuService.setSelectedMenu(linkName);
  }

  // onSubmit(form: any) {
  //   if (form.valid) {
  //     this.loginService.validateUser(this.username, this.password).subscribe(
  //       (data) => {
  //         
  //           
  //           this.userService.setUserId(data.id);
  //           this.userService.setRole(data.role);
  //           this.userService.setRoleId(data.roleId);
  //           this.userService.setFirstName(data.firstName);
  //           this.userService.setLastName(data.lastName);
  //           this.userService.setCustomerId(data.customerID);
  //           if (data.Result.role === 'LSA') {
  //             this.onSidebarLinkClick('Minimum Wages');
  //             this.router.navigate(['/MinimumWagesPeriod']);
  //           } else {
  //             this.router.navigate(['/EntityDashboard']);
  //           }
  //       },
  //       (error) => {
  //         
  //         this.loginError = true;
  //       }
  //     );
  //   }
  // }

  onSubmit(form: any) {
    
    this.userService.clearUserData();
    sessionStorage.setItem('selectedYear', '');
    if (form.valid) {
      this.loginService.validateUser(this.loginusername, this.loginpassword).subscribe({
        next: (response) => {
          if (response.status === 200) {
            const data = response.body;
            // Guard: if the response is incomplete, DON'T redirect (which would land
            // the user in a broken session) — flag a login error instead. Checked
            // before any session data is set so we never half-populate UserService.
            const hasValue = (v: any) => v !== null && v !== undefined && v !== '';
            const isValidLogin = Boolean(data)
              && hasValue(data.id)
              && hasValue(data.role)
              && hasValue(data.roleId)
              && hasValue(data.firstName)
              && hasValue(data.lastName)
              && hasValue(data.customerID)
              && hasValue(data.token)
              && hasValue(data.refreshToken);
            // Note: serviceProviderID, zone and isChangePasswordRedirect can be
            // null/0 for valid users, so they are intentionally NOT required here.
            if (!isValidLogin) {
              this.loginError = true;
              return;
            }
            this.userService.setUserId(data.id);
            this.userService.setRole(data.role);
            this.userService.setRoleId(data.roleId);
            this.userService.setFirstName(data.firstName);
            this.userService.setLastName(data.lastName);
            this.userService.setCustomerId(data.customerID);
            this.userService.setAccessToken(data.token);
            this.userService.setRefreshToken(data.refreshToken);
            this.userService.setServiceProviderID(data.serviceProviderID);
            this.userService.setZone(data.zone);
            this.loginService.IsDefaultPassword(data.id).subscribe({
              next: (res) => {
                if (Number(res.body) === 1) {
                  sessionStorage.setItem('showChangePasswordPopup', '1');
                  this.router.navigate(['/ForgetPassword']);
                } else {
                  this.handleRoleRedirection(data.role);
                }
              },
              error: () => {
                // Don't block login if the check fails — proceed with normal redirection.
                // this.handleRoleRedirection(data.role);
              }
            });
          } else {
            this.loginError = true;
          }
        },
        error: (err) => {
          this.loginError = true;
        }
      });
    }
  }

  private handleRoleRedirection(role: string): void {
    switch (role) {
      case 'LSA':
        this.onSidebarLinkClick('Master Abstracts');
        this.router.navigate(['/Master_Abstracts']);
        break;

      case 'CORDN':
      case 'SME':
      case 'SDEXE':
        this.router.navigate(['/Notices']);
        break;

      case 'RCP':
        this.onSidebarLinkClick('Registration');
        this.router.navigate(['/NewRegistrationLicense']);
        break;

      case 'BT':
        this.onSidebarLinkClick('Invoice Setup');
        this.router.navigate(['/ClientCommercialSetup']);
        break;

      case 'LFT':
        this.onSidebarLinkClick('CN Approval');
        this.router.navigate(['/CreditNoteApproval']);
        break;

      case 'HMGR':
      case 'HAPPR':
      case 'HRLN':
      case 'HRL':
      case 'HRN':
      case 'TLOpsHead':
      case 'TLOpsLead':
      case 'TLManagement':
      case 'TLZonalhead':
      case 'TLSMEHead':
      case 'TLRCPHead':
      case 'TLAccManager':
      case 'TLFinanceAdmin':
      case 'TLAuditor':
      case 'TLAuditorHead':
        this.onSidebarLinkClick('Dashboard');
        this.router.navigate(['/ClientDashboard']);
        break;

      case 'TLMGT':
      case 'TLACM':
      case 'TLOPH':
      case 'CORDH':
      case 'TLRM':
      case 'TLCOM':
      case 'TLOPL':
      case 'CORDN':
        this.onSidebarLinkClick('Dashboard');
        this.router.navigate(['/InternalDashboard']);
        break;

      case 'TLRCH':
        this.onSidebarLinkClick('Dashboard');
        this.router.navigate(['/RCPHeadDashboard']);
        break;

      case 'TLAUD':
        this.onSidebarLinkClick('Dashboard');
        this.router.navigate(['/Audit']);
        break;

      default:
        this.router.navigate(['/EntityDashboard']);
        break;
    }
  }
}